import store from '../../store/store';
import { getGuid } from 'owa-guid';
import { getClientId } from 'owa-session-store';
import { getClientVersion } from 'owa-session-store';

export default function setOgmaHeaders(req: XMLHttpRequest) {
    req.setRequestHeader('Content-type', 'application/json');
    req.setRequestHeader('Accept', 'application/json, text/plain, */*');
    req.setRequestHeader('x-translator-sid', store.sessionId);
    req.setRequestHeader('x-translator-cross-sid', store.sessionId);
    // OWA does not implement correlation id, so we pass random guid every request
    req.setRequestHeader('x-translator-cid', getGuid());
    // User ID is used in OGMA for throttling
    req.setRequestHeader('x-translator-user-id', getClientId());
    req.setRequestHeader('x-translator-client-version', getClientVersion());
    req.setRequestHeader('x-translator-client-app', 'Outlook');
    req.setRequestHeader('x-translator-client-type', 'Browser');
}
